import { render, staticRenderFns } from "./GPtransferRecordReport.vue?vue&type=template&id=5d7d3997&scoped=true"
import script from "./GPtransferRecordReport.vue?vue&type=script&lang=js"
export * from "./GPtransferRecordReport.vue?vue&type=script&lang=js"
import style0 from "./GPtransferRecordReport.vue?vue&type=style&index=0&id=5d7d3997&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d3997",
  null
  
)

export default component.exports